var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-skeleton',{staticClass:"loading-list-table",attrs:{"active":"","title":false,"paragraph":{ rows: _vm.rows, width: '100%' }}})
}
var staticRenderFns = []

export { render, staticRenderFns }